import axios from 'axios'
import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import store from './store/index.js'
import Buefy from 'buefy'
import VueGtm from '@gtm-support/vue2-gtm'
import * as Sentry from '@sentry/vue'
import '@/assets/scss/app.scss'
import '@/filters.js'
import VVoid from '@/components/VVoid.js'

const debug = process.env.NODE_ENV !== 'production'
const localVersion = process.env.VUE_APP_VERSION
const releaseIdentifier = `sonata-fe@${localVersion}`
const isPrerender = Boolean(window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.isPrerender)

// This has to be setup in @/api/client.js as well.
if (process.env.VUE_APP_API_BASE_URL) {
  axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
}

if (!isPrerender && process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID) {
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID,
    enabled: true,
    debug,
    vueRouter: router
  })
}

// Check if out backend version matches the live backend version.
if (process.env.NODE_ENV !== 'development') {
  const updateSeconds = 60
  setInterval(function () {
    axios.get('/info/')
      .then((response) => {
        const remoteVersion = response.data.frontend_version
        if (localVersion !== remoteVersion) {
          if (debug) {
            console.log(`Version mismatch between local ${localVersion} and remote ${remoteVersion}`)
          }
          window.location.reload(true)
        }
      })
      .catch(() => {})
  }, updateSeconds * 1000)
}

// Setup Vue
Vue.use(Buefy)

Vue.config.productionTip = false
Vue.config.performance = debug

// Register global components
Vue.component('VVoid', VVoid)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

if (!isPrerender && process.env.VUE_APP_SENTRY_DSN) {
  const tracesSampleRate = parseFloat(process.env.VUE_APP_SENTRY_TRACE_SAMPLE_RATE)
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    release: releaseIdentifier,
    integrations: [
      new Sentry.BrowserTracing({ tracingOrigins: [process.env.VUE_APP_API_BASE_URL] })
    ],
    tracesSampleRate: Number.isFinite(tracesSampleRate) ? tracesSampleRate : 0,
    trackComponents: true,
    logErrors: true
  })
}

if (!isPrerender && process.env.VUE_APP_LOGROCKET_APP_ID) {
  import('logrocket').then(({ default: LogRocket }) => {
    LogRocket.init(process.env.VUE_APP_LOGROCKET_APP_ID, {
      release: releaseIdentifier,
      dom: {
        // Don't record user input from elements.
        inputSanitizer: true
      },
      network: {
        requestSanitizer: request => {
          // Let's not send the API auth token to logrocket.
          if ('Authorization' in request.headers) {
            request.headers.Authorization = ''
          }
          return request
        },
        responseSanitizer: response => {
          if (response.url.indexOf('/api/token-auth') > -1) {
            response.body = null
          }
          return response
        }
      }
    })

    if (process.env.VUE_APP_SENTRY_DSN) {
      LogRocket.getSessionURL(sessionURL => {
        Sentry.getCurrentScope().setExtra('logrocketURL', sessionURL)
      })
    }
  })
}
